/* eslint-disable react/forbid-component-props */
import classNames from 'classnames';
import React from 'react';

import commonStyles from '@css/outline.scss';

import styles from './caption.scss';


export function mainContainerStyles({ containerStyles, hasBorderStyle, hasHoverStyle }) {
  return classNames(styles.caption, containerStyles, {
    [commonStyles.hasBorder]: hasBorderStyle,
    [commonStyles.hasHover]: hasHoverStyle
  });
}

interface CaptionProps {
  ariaHidden?: boolean;
  children?: React.ReactNode;
  containerElement?: string;
  containerStyles?: string;
  hasBorderStyle?: boolean;
  hasHoverStyle?: boolean;
}

export default function Caption({
  ariaHidden,
  children,
  containerElement = 'div',
  containerStyles,
  hasBorderStyle,
  hasHoverStyle
}: CaptionProps) {
  const captionContainerStyles = mainContainerStyles({
    containerStyles,
    hasBorderStyle,
    hasHoverStyle
  });
  const Container = containerElement;
  return (
    <Container aria-hidden={ariaHidden} className={captionContainerStyles}>
      {children}
    </Container>
  );
}
